import { render } from "./mpTable.vue?vue&type=template&id=4335436a"
import script from "./mpTable.vue?vue&type=script&lang=js"
export * from "./mpTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__